import React from "react";
import { ContextMenuItemProps } from "./types";
import { ContextMenuContext } from "./context";
import { MenuItem } from "@mui/material";
import { Box, Spinner } from "@origin-digital/ods-core";

export function ContextMenuItem<T = void>({
  children,
  onHandleClick,
  onResult,
  onError,
}: ContextMenuItemProps<T>) {
  const { handleClose } = React.useContext(ContextMenuContext);
  const [loading, setLoading] = React.useState(false);

  const handleClick = async (
    e: React.MouseEvent<HTMLLIElement, MouseEvent>
  ) => {
    e.stopPropagation();
    setLoading(true);
    try {
      const result = await Promise.resolve(onHandleClick(e));
      onResult?.(result);
    } catch (error) {
      onError?.(error);
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  return (
    <MenuItem onClick={handleClick}>
      {loading ? (
        <Box
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "0px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spinner />
        </Box>
      ) : (
        children
      )}
    </MenuItem>
  );
}
